<template>
    <div id="editar">
        <personales     v-if="Tipo=='personales'"       ></personales>
        <foto           v-if="Tipo=='foto'"             ></foto>
        <dni            v-if="Tipo=='dni'"              ></dni>
        <titulo         v-if="Tipo=='titulo'"           ></titulo>
        <cargos         v-if="Tipo=='cargos'"           ></cargos>
        <niveles        v-if="Tipo=='niveles'"          ></niveles>
        <modalidades    v-if="Tipo=='modalidades'"      ></modalidades>
        <areas          v-if="Tipo=='areas'"            ></areas>
        <escuelas       v-if="Tipo=='establecimientos'" ></escuelas>
        <circuitos      v-if="Tipo=='circuitos'"        ></circuitos>
    </div>
</template>


<script>
  /*  import axios                    from 'axios';*/
    import Editar_Areas             from './Editar_Areas';
    import Editar_Cargos            from './Editar_Cargos';
    import Editar_Circuitos         from './Editar_Circuitos';
    import Editar_DNI               from './Editar_DNI';
    import Editar_Escuelas          from './Editar_Escuelas';
    import Editar_Foto              from './Editar_Foto';
    import Editar_Modalidades       from './Editar_Modalidades';
    import Editar_Niveles           from './Editar_Niveles';
    import Editar_Personales        from './Editar_Personales';
    import Editar_Titulo            from './Editar_Titulo';

    export default
    {   data()
        {   return {
                Tipo:               this.$route.params.id,
            }
        },


        components: {
            'areas':                Editar_Areas,
            'cargos':               Editar_Cargos,
            'circuitos':            Editar_Circuitos,
            'dni':                  Editar_DNI,
            'escuelas':             Editar_Escuelas,
            'foto':                 Editar_Foto,
            'modalidades':          Editar_Modalidades,
            'niveles':              Editar_Niveles,
            'personales':           Editar_Personales,
            'titulo':               Editar_Titulo,
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
        }
    }
</script>
